export var StoreStateEnum;
(function (StoreStateEnum) {
    StoreStateEnum["ACTIVE"] = "ACTIVE";
    StoreStateEnum["ON_HOLD"] = "ON_HOLD";
    StoreStateEnum["CHURNED"] = "CHURNED";
    StoreStateEnum["ONBOARDING"] = "ONBOARDING";
})(StoreStateEnum || (StoreStateEnum = {}));
//# sourceMappingURL=store-state.enum.js.map